
import Loading from 'vux/src/components/loading/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
Loading,
ViewBox,
XHeader
}
}



// WEBPACK FOOTER //
// ./src/components/Usdt5.vue